import { ApiClient } from "../ApiClient";

/**
 * Fetch reviews submitted by the current user
 * @param {string} url - The dynamic endpoint path
 * @returns {Promise<Response>}
 */
export const fetchUserReviewList = async (url) => {
  // ApiClient.get handles baseUrl, headers, and credentials
  return ApiClient.get(url);
};

/**
 * Fetch a list of reviews (General/Public or Admin)
 * @param {string} url - The dynamic endpoint path
 * @returns {Promise<Response>}
 */
export const fetchReviewList = async (url) => {
  return ApiClient.get(url);
};

/**
 * Create a new review
 * @param {string} url - The dynamic endpoint path
 * @param {Object} queryData - The review payload
 * @returns {Promise<Response>}
 */
export const createReview = async (url, queryData) => {
  // ApiClient.post handles baseUrl, CSRF, and JSON stringification.
  // Note: Your original code had a small bug (missing 'await' on getCsrfToken),
  // but ApiClient.post fixes this by handling the token internally.
  return ApiClient.post(url, queryData);
};
